import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { User } from 'src/app/shareModule/models/user.model';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Component({
  selector: 'app-advanced-settings-preferences',
  templateUrl: './advanced-settings-preferences.component.html',
  styleUrls: [
    './advanced-settings-preferences.component.scss',
    '../advanced-settings.component.scss',
  ],
})
export class AdvancedSettingsPreferencesComponent implements OnInit {
  constructor(
    private sharedService: SharedService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private auth: AuthServiceService
  ) { }

  public userInfo: any = {};
  public modalRef: any = null;
  private newNotifVal = false;

  public AISettingsTab: any = [{ title: 'Learn' }, { title: 'Memory' }];
  validSubscription: boolean;
  public categoryTabs: any = [
    { name: 'Popular', checked: false },
    { name: 'Latest', checked: false },
    { name: 'Friends', checked: false },
    { name: 'Food & Beverage', checked: false },
    { name: 'Local Delights', checked: false },
    { name: 'Free', checked: false },
    { name: 'Tuition', checked: false },
    { name: 'Pets', checked: false },
  ];

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((response: User) => {
      const data = response;
      this.userInfo = {
        buyerContact: data.buyerContact,
        allowTelegramContact: data.allowTelegramContact,
        isTelegramVerified: data.isTelegramVerified,
        showCardOnProducts: data.showCardOnProducts,
        allowBotChat: data.allowBotChat,
        addMainAIInMyChat: data.addMainAIInMyChat,
        sendMeEmailWhenNewChatStarts: data.sendMeEmailWhenNewChatStarts,
        referralCode: data.referralCode,
        level: data.level,
        hiddenCategoryTab:
          data.hiddenCategoryTab,
        turnOffWhatsapp: data.turnOffWhatsapp,
        showMeNotificationWeb: this.newNotifVal ? 1 : 0,
        enableTemplate: data.enableTemplate,
      };
      this.validSubscription = response?.subscription != null;

      if (this.userInfo.allowTelegramContact && this.userInfo.buyerContact) {
        this.userInfo.allowTelegramContact = 0;
      }

      this.categoryTabs.map((row: any) => {
        if (!this.userInfo.hiddenCategoryTab.includes(row.name)) {
          row.checked = true;
        }
      });

      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  startTutorials() {
    localStorage.setItem('tutorials', JSON.stringify(true));
    this.sharedService.shepherd('new-user');
  }

  public allowWhatsappChange() {
    if (this.userInfo.allowTelegramContact && this.userInfo.buyerContact) {
      this.userInfo.allowTelegramContact = 0;
      this.toastr.info('Allowing both telegram and whatsapp is not allowed');
    }
  }

  public allowTelegramContactChange() {
    if (!this.userInfo.isTelegramVerified) {
      this.local.alertInfo({
        title: 'Telegram Contact',
        message:
          'Please make sure you have verified you telegram phone in super seller(chat settings).',
      });

      this.userInfo.allowTelegramContact = false;
      return;
    }
    if (this.userInfo.allowTelegramContact && this.userInfo.buyerContact) {
      this.userInfo.buyerContact = false;
      this.toastr.info('Allowing both telegram and whatsapp is not allowed');
    }
    if (this.userInfo.allowTelegramContact) {
      this.local.alertInfo({
        title: 'Telegram Contact',
        message:
          'Please make sure the phone number of your whatsapp has a telegram and is reachable using the phone number.',
      });
    }
  }

  public openAISettingTab(modal: any) {
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'aisetting-modal my-modal sm',
    });
  }

  public setProfileToDefault(type = 'default') {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to set your profile to default?',
      })
      .then((result) => {
        if (result.value) {
          this.customerService
            .setProfileToDefault({
              referralCode: this.userInfo.referralCode,
              level: this.userInfo.level,
              type: type,
            })
            .subscribe(
              (response: any) => {
                this.toastr.success(
                  response.message || 'Profile set to default successfully'
                );
              },
              (e) => {
                this.toastr.error(
                  e.error.message || 'Failed to set profile to default'
                );
              }
            );
        }
      });
  }

  setProfileToAvatar() {
    this.setProfileToDefault('avatar');
  }

  get showMeNotifications() {
    if ('Notification' in window) {
      return (
        (Notification.permission === 'granted' &&
          this.userInfo?.showMeNotificationWeb) ||
        this.newNotifVal
      );
    }
    return false;
  }

  set showMeNotifications(val) {
    if (val) {
      Notification.requestPermission().then((v) => {
        if (val) {
          this.newNotifVal = val;
        }
      });
    } else {
      this.newNotifVal = val;
    }
  }

  public saveProfileInfo(): void {
    let payload = this.userInfo;

    payload.hiddenCategoryTab = this.categoryTabs.filter((row: any) => !row.checked).map((row: any) => row.name).join('|');

    console.log('payload', payload)
    const formData = new FormData();

    Object.keys(payload).map((row) => {
      if (typeof payload[row] === 'boolean') {
        formData.append(row, payload[row] ? '1' : '0');
      } else {
        formData.append(row, payload[row]);
      }
    });

    this.auth.updateProfileCharacterDetails(formData).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.store.dispatch(loadUser({}));
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }
}
